import React from "react";

import { Stack, Text, useTheme } from "@bps/fluent-ui";

import { JobsConfigurationJob } from "./dtos";
import { JobDeleteButton } from "./JobDeleteButton";
import { JobEditButton } from "./JobEditButton";

interface JobListItemProps {
  job: JobsConfigurationJob;
  onDeleteJob: (job: JobsConfigurationJob) => void;
  onUpdateJob: (job: JobsConfigurationJob) => void;
}

export const JobListItem: React.FC<JobListItemProps> = ({
  job,
  onUpdateJob,
  onDeleteJob
}) => {
  const theme = useTheme();
  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      verticalAlign="center"
      styles={{
        root: {
          "& .JobListItemActions": {
            opacity: 0
          },
          "&:hover .JobListItemActions": {
            opacity: 1
          }
        }
      }}
    >
      <Text>{job.code ?? job.name}</Text>
      <Stack
        className="JobListItemActions"
        horizontal
        tokens={{ childrenGap: theme.spacing.s2 }}
      >
        <JobEditButton job={job} onUpdateJob={onUpdateJob} />
        <JobDeleteButton job={job} onDeleteJob={onDeleteJob} />
      </Stack>
    </Stack>
  );
};
